import { ID_TYPES, PAYMENT_MODES, STATUS_OPTIONS, TRANSACTION_TYPES } from '../../../resources/enums';
import { Account, IAccount } from '../account/Account';
import { IUser, User } from '../User';

export class Transaction {
  id: string;
  amount: number;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  type: TRANSACTION_TYPES;
  account_id: string;
  transaction_by: string;
  transactor_id_number: string;
  transactor_id_type: ID_TYPES;
  transactor_phone: string;
  transactor_address: string;
  description: string;
  account: Account;
  balance_after: number;
  transaction_mode: PAYMENT_MODES;
  createdBy: User;
  created_by_user_id: string;
  status: STATUS_OPTIONS;
  is_system_transaction: boolean;

  constructor(IModel: ITransaction) {
    this.id = IModel.id;
    this.amount = IModel.amount;
    this.createdAt = IModel.created_at ? new Date(IModel.created_at) : undefined;
    this.updatedAt = IModel.updated_at ? new Date(IModel.updated_at) : undefined;
    this.type = IModel.type as TRANSACTION_TYPES;
    this.account_id = IModel.account_id;
    this.transaction_by = IModel.transaction_by;
    this.transactor_id_number = IModel.transactor_id_number;
    this.transactor_phone = IModel.transactor_phone;
    this.transactor_id_type = IModel.transactor_id_type as ID_TYPES;
    this.transactor_address = IModel.transactor_address;
    this.description = IModel.description;
    this.account = IModel.account && new Account(IModel.account);
    this.balance_after = IModel.balance_after;
    this.transaction_mode = IModel.transaction_mode;
    this.createdBy = IModel.created_by && new User(IModel.created_by);
    this.created_by_user_id = IModel.created_by_user_id;
    this.status = IModel.status;
    this.is_system_transaction = IModel.is_system_transaction;
  }

  isDeposit = (): boolean => {
    return this.type === TRANSACTION_TYPES.CREDIT;
  }

  isPending = (): boolean => {
    return this.status === STATUS_OPTIONS.PENDING;
  }
}

export interface ITransaction {
  id: string;
  amount: number;
  created_at: string;
  updated_at: string;
  transactionType: string;
  account_id: string;
  type: string;
  transaction_by: string;
  transactor_id_number: string;
  transactor_id_type: string;
  transactor_phone: string;
  transactor_address: string;
  description: string;
  account: IAccount;
  balance_after: number;
  transaction_mode: PAYMENT_MODES;
  created_by: IUser;
  created_by_user_id: string;
  status: STATUS_OPTIONS;
  is_system_transaction: boolean;
}
